import script from "./ContactUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUpdate.vue?vue&type=script&setup=true&lang=js"

import "./ContactUpdate.vue?vue&type=style&index=0&id=c8c01bd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8c01bd0"]])

export default __exports__